import { render } from "./DocumentsList.vue?vue&type=template&id=fe510650"
import script from "./DocumentsList.vue?vue&type=script&lang=js"
export * from "./DocumentsList.vue?vue&type=script&lang=js"

import "./DocumentsList.vue?vue&type=style&index=0&id=fe510650&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__